import styles from './Legal.module.css';
import { SectionWrapper } from '../components/shared/SectionWrapper';
import { useSEO } from '../hooks/useSEO';

export function Cookies() {
  useSEO({
    title: 'Cookie Policy',
    description: 'LuvLust Cookie Policy. Learn about how we use cookies and similar technologies.',
    keywords: 'luvlust cookies, cookie policy, tracking technologies',
  });

  return (
    <SectionWrapper>
      <article className={styles.legal}>
        <h1 className={`display ${styles.title}`}>Cookie Policy</h1>
        <p className={styles.date}>Last updated: June 12, 2026</p>

        <h2>What Are Cookies</h2>
        <p>Cookies are small text files that are placed on your device when you visit a website. They are widely used to make websites work more efficiently and to provide information to the site owners.</p>

        <h2>How We Use Cookies</h2>
        <p>The LuvLust website (luvlustapp.com) uses cookies and similar technologies for the following purposes:</p>
        <ul>
          <li><strong>Essential Cookies:</strong> Required for the website to function properly, including session management and security features.</li>
          <li><strong>Analytics Cookies:</strong> Help us understand how visitors interact with our website by collecting anonymous usage data (e.g., pages visited, time on site).</li>
          <li><strong>Performance Cookies:</strong> Allow us to monitor and improve the performance of our website.</li>
        </ul>

        <h2>Third-Party Cookies</h2>
        <p>We may use third-party services that set their own cookies, including:</p>
        <ul>
          <li><strong>Google Analytics:</strong> For website traffic analysis. <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Google Privacy Policy</a></li>
          <li><strong>Firebase Analytics:</strong> For website traffic and engagement measurement. <a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer">Firebase Privacy</a></li>
        </ul>

        <h2>Managing Cookies</h2>
        <p>Most web browsers allow you to control cookies through their settings. You can set your browser to refuse cookies or to alert you when cookies are being sent. Note that disabling cookies may affect the functionality of some parts of our website.</p>

        <h2>Changes to This Policy</h2>
        <p>We may update this Cookie Policy from time to time. Changes will be posted on this page with an updated revision date.</p>

        <h2>Contact Us</h2>
        <p>If you have questions about our use of cookies, please contact us at:</p>
        <p><a href="mailto:starlitapps.dev@gmail.com">starlitapps.dev@gmail.com</a></p>
      </article>
    </SectionWrapper>
  );
}
